import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'

interface MassActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  count: number
}

export function MassActions({
  count,
  children,
  className,
  ...props
}: MassActionsProps) {
  const { t } = useTranslation()
  return (
    <div className={cn('flex items-center gap-5', className)} {...props}>
      <span className="whitespace-nowrap text-sm text-gray-500">
        {t('toolbar.selectedCount', { count })}
      </span>
      <MassActionsDivider />
      {children}
    </div>
  )
}

interface MassActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode
  label: string
}

function MassActionButton({
  icon,
  label,
  className,
  ...props
}: MassActionButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        'flex h-8 shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-gray-200 bg-white px-2 py-1 text-sm text-gray-500 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white',
        className,
      )}
      {...props}
    >
      <span className="flex size-4.5 items-center justify-center">{icon}</span>
      {label}
    </button>
  )
}

function MassActionsDivider() {
  return <div className="h-8 w-px bg-gray-200" />
}

MassActions.Button = MassActionButton
MassActions.Divider = MassActionsDivider
